import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import React, { useState, useEffect } from 'react';
import { getAllCohorts } from '../../../services/apiService';

const CohortSelection = ({ value, setValue }) => {
  const [cohorts, setCohorts] = useState([]);

  const fetchCohorts = async () => {
    const response = await getAllCohorts();
    setCohorts(response);
  };

  useEffect(() => {
    fetchCohorts();
  }, []);

  return (
    <Autocomplete
      id='cohort-combo-box'
      options={cohorts}
      getOptionLabel={(option) => {
        if (typeof option === 'string') return option;
        return option.name;
      }}
      value={value}
      onChange={(e, newValue) => setValue(newValue)}
      loading={cohorts.length === 0}
      renderInput={(params) => (
        <TextField {...params} label='Combo box' variant='outlined' />
      )}
    />
  );
};

export default CohortSelection;
